// src/features/compliance/services/compliance.js
import { apiClient } from '../../../services/api/client';

export const complianceAPI = {
  getExpiryOverview: () =>
    apiClient.get('/api/v1/compliance/expiry-overview'),

  getApprovalsOverview: () =>
    apiClient.get('/api/v1/compliance/approvals-overview'),
};
